import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, FormControlLabel, Radio } from 'edenred-ui';
import { useTheme } from 'styled-components';

import { InvoicingMethod } from '@epi-forms/helpers';
import { InvoicingMethodFieldProps } from '@epi-models/forms/Controls';
import {
  EInvoice,
  EInvoiceAddressField,
  OperatorField
} from '@epi-forms/controls/EInvoice';

export function EInvoiceField({
  readOnly,
  isActive
}: InvoicingMethodFieldProps) {
  const { altGray2, primaryBackColorLight10 } = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      border={`1px solid ${altGray2}`}
      px={3}
      pt={2}
      pb={4}
      mt={3}
      bgcolor={isActive ? primaryBackColorLight10 : undefined}
    >
      <FormControlLabel
        value={InvoicingMethod.EInvoice}
        control={<Radio />}
        label={t('controls.einvoice_radio_label')}
        readOnly={readOnly}
        id="invoicing-method_einvoice"
      />
      <EInvoice>
        <Box display="flex" gap={3}>
          <EInvoiceAddressField
            readOnly={readOnly}
            required={isActive}
            disabled={!isActive}
          />
          <OperatorField
            readOnly={readOnly}
            required={isActive}
            disabled={!isActive}
          />
        </Box>
      </EInvoice>
    </Box>
  );
}
